


































































import gql from '@/gqlService.coffee'

export default {
    name: 'EstablishmentModal'
    components: {}
    # props:
    computed:
        computed_filters: ()->
            return {
                "establishment__uid": this.$store.state.selected_establishment_uid
            }
    data: ()->
        return {
            "connection_set": new gql.DataHolder({
                "model": "connection_set",
                "fields": "uid login password info establishment_link platform{name}"
                "autoload": false,
                "filters": null
            })
        }
    methods:
        query: ()->
            vm = this
            vm.connection_set.query(vm.computed_filters)
        copyPass: (index)->
            refLabel = 'pass' + index
            el = this.$refs[refLabel][0]
            el.select()
            document.execCommand( 'copy' ) 
            this.$store.dispatch("notify",{
                level: "success",
                text: "Copié!",
                seconds: 2
            })
    watch:
        "$store.state.selected_establishment_uid": (newV, oldV)->
            if newV?
                this.query()
        
}
